import * as React from 'react';
import { Props as CloseButtonProps } from './index';
import { observer } from 'mobx-react';
import styles from './index.scss';

interface Props extends CloseButtonProps {
  displayAfter?: number;
  elapsedTime?: number;
  isViewable: boolean;
}

let rendered = false;
let currentAnimationFrame: number | null = null;
let animationDuration: string | null = null;

export const CountdownCloseButton = observer((props: Props) => {
  const {
    iconSize = 15,
    iconPadding = 4,
    iconColor = '#FFFFFF',
    style,
    controlBlockStyle = {},
    displayAfter = 3,
    elapsedTime = 0,
    isViewable
  } = props;

  const countdownLineSize: number = 1.5;
  const countdownRadius: number = Math.floor(
    (iconSize - countdownLineSize) / 2
  );
  const countdownPerimeter: number = Math.floor(2 * Math.PI * countdownRadius);

  if (!currentAnimationFrame) {
    currentAnimationFrame = countdownPerimeter;
  }

  if (!animationDuration) {
    animationDuration = `${displayAfter}s`;
  }

  const svgPosition: React.CSSProperties = {
    position: 'relative',
    width: iconSize,
    height: iconSize,
    transform: 'rotateZ(-90deg)'
  };

  const showCountdown = displayAfter > elapsedTime;
  if (isViewable && !rendered) {
    rendered = true;
  }

  if (!isViewable && rendered && showCountdown) {
    currentAnimationFrame = Math.round(
      countdownPerimeter - (countdownPerimeter / displayAfter) * elapsedTime
    );
    animationDuration = `${displayAfter - elapsedTime}s`;
    rendered = false;
  }

  return (
    <>
      {isViewable && (
        <div style={controlBlockStyle}>
          <div
            style={{
              height: iconSize + iconPadding * 2,
              width: iconSize + iconPadding * 2,
              padding: iconPadding,
              ...style
            }}
            className={styles.closeButton}
          >
            <svg style={svgPosition}>
              <circle
                r={countdownRadius}
                cx="50%"
                cy="50%"
                stroke={iconColor}
                strokeWidth={countdownLineSize}
                fill="none"
                strokeDasharray={countdownPerimeter}
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from={currentAnimationFrame}
                  to="0"
                  dur={animationDuration}
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </div>
        </div>
      )}
    </>
  );
});
